export default __webpack_public_path__ + "static/media/bn_buenfin_coche.6909cfe6.jpg";